import styled from "styled-components";

export const InputBox = styled.input`
  width: 100%;
  height: 44pxpx;
  padding: 10px 20px;
  border: 0.75px solid var(--bg-back-button);
  border-radius: 3px;
  background-color: transparent;
  color: var(--text-color);
  font-weight: 400;
  font-size: 13px;
  line-height: 1.45;
  -moz-appearance: textfield;
  transition: border-color 250ms linear;

  &:hover,
  &:focus,
  &:focus-visible {
    outline: none;
    border-color: var(--bg-button);
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
      -webkit-appearance: none;
  }

`;
